import { z } from 'zod';
export const WorkspaceCryptoResponseSchema = z.object({
    id: z.string(),
    adminPublicKey: z.string(),
    everyonePublicKey: z.string(),
    sEveryoneByAdminKey: z.string(),
    eEveryonePrivateKeyByAdminKey: z.string(),
    eWorkspaceCommonKeyByAdminKey: z.string(),
});
